import React from "react";
import styles from "./Rewards.module.scss";
import Image from "next/image";

const Rewards = () => {
  return (
    <section className={styles.reward}>
      <div className={styles.blobBottom} />
      <div className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.title}>
            Earn
            <br />
            <span className={styles.titleSpan}> 5x Rewards </span>
          </h1>
          <p className={styles.paragraph}>
            The B-Love Network app has been designed to reward each user with 5x
            rewards. With a 1% daily reward, the B-Love Network plan will reward
            the users for a time period of 500 days.
          </p>
          <button className={styles.btn}>Learn More</button>
        </div>
        <div className={styles.image}>
          <Image
            alt='rewards'
            src='/assets/Image/rewards.png'
            width={615}
            height={420}
            quality
            priority
            className=""
          />
        </div>
      </div>
    </section>
  )
};

export default Rewards;
